var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fullpage-modal__header secondary-text" },
    [
      _c("transition", { attrs: { name: "fade", mode: "out-in" } }, [
        _vm.showBack
          ? _c(
              "button",
              {
                staticClass: "round-icon-button secondary-text",
                attrs: { type: "button", "aria-label": _vm.backLabel },
                on: {
                  click: function($event) {
                    return _vm.$emit("back")
                  }
                }
              },
              [_c("span", { staticClass: "icon-arrow rotate-180" })]
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.showBack
          ? _c("div", [_c("logo", { attrs: { disableFocus: "" } })], 1)
          : _vm._e()
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "d-md-none round-icon-button primary-background",
          attrs: { type: "button", "aria-label": _vm.closeLabel },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_c("span", { staticClass: "icon-close secondary-text" })]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass:
            "d-none d-md-inline-block round-icon-button secondary-background",
          attrs: { type: "button", "aria-label": _vm.closeLabel },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_c("span", { staticClass: "icon-close primary-text" })]
      ),
      _vm._v(" "),
      _vm.search
        ? _c(
            "button",
            {
              staticClass:
                "round-icon-button primary-background secondary-text d-md-none",
              attrs: { type: "button", "aria-label": _vm.closeLabel },
              on: {
                click: function($event) {
                  return _vm.$emit("close-search")
                }
              }
            },
            [_c("span", { staticClass: "icon-menu" })]
          )
        : _c(
            "button",
            {
              staticClass:
                "round-icon-button primary-background secondary-text d-md-none",
              attrs: { type: "button", "aria-label": _vm.searchLabel },
              on: {
                click: function($event) {
                  return _vm.$emit("open-search")
                }
              }
            },
            [_c("span", { staticClass: "icon-search" })]
          ),
      _vm._v(" "),
      _c("lang-select", {
        staticClass: "d-none d-md-block",
        attrs: { disableFocus: "" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }